export interface User {
  id: number;
  profile_id: number | null;
  role_id: number;
  name: string;
  email: string;
  mobile: string | null;
  email_verified_at: string | null;
  is_active: number;
  created_by: number | null;
  updated_by: number | null;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface AuthState {
  user: User | null;
  id: number | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  user: null,
  id: null,
  token: null,
  isLoading: false,
  error: null
};